import { apiClient } from "../config";

async function editForm(id: string , data:any) {
  const res = await apiClient.put(`/admin/dynamic-forms/${id}`, data);
  return res.data;
}

export default editForm;
